/* global expense, amounts, listQuantityItems, imgUrl, assignedToEvent, errors, expenseReadonly, canBeEdited, requestsUrl, showPendingRequestWarning */

import React, { Fragment, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import HasPendingRequestWarning from '../budget_approval_requests/HasPendingRequestWarning';

import ExpenseQuantityEdit from './ExpenseQuantityEdit';

import { parseLocaleNumber } from 'Helpers/currencyFormat';

export default function UncommittedTable(props) {
    const [selectedAmounts, setSelectedAmounts] = useState(amounts);
    const [list, setList] = useState(listQuantityItems);
    const [availableLists, setAvailableLists] = useState([]);
    const [slotLinkStates] = useState(() => {
        if (typeof window.quantityLinkSlotStates !== 'undefined') {
            return window.quantityLinkSlotStates;
        }
        return null;
    });

    useEffect(() => {
        const handleChanged = () => {
            if (!window.quantityLinkEnabled || !window.quantityLinkExpenseId) return;
            window.location.reload();
        };
        window.addEventListener('quantitylink:changed', handleChanged);
        return () => window.removeEventListener('quantitylink:changed', handleChanged);
    }, []);

    useEffect(() => {
        $('#price').val(expense.price);
        const avLists = JSON.parse(JSON.stringify(availableLists));
        avLists[0] = availableList(0);
        setAvailableLists[avLists];

        if (selectedAmounts.length === 0) {
            const res = [];
            res.push({
                name: avLists[0],
                amount: 1,
                expenseReadonly: props.expenseReadonly,
                canBeEdited: props.canBeEdited,
            });
            setSelectedAmounts(res);
        }

        let tempSelectedAmounts = selectedAmounts;
        tempSelectedAmounts.forEach((selectedAmount) => {
            selectedAmount['expenseReadonly'] = props.expenseReadonly;
            selectedAmount['canBeEdited'] = props.canBeEdited;
        });
        setSelectedAmounts(tempSelectedAmounts);
    }, []);

    useEffect(() => {
        const avLists = JSON.parse(JSON.stringify(availableLists));
        selectedAmounts.forEach((item, index) => {
            avLists[index] = availableList(index);
        });
        setAvailableLists[avLists];
        calculateTotal();
    }, [list, selectedAmounts]);

    const changePrice = (e) => {
        $('#price').trigger('keypress');
        $('#price').trigger('keyup');
        calculateTotal();
    };

    const calculateTotal = () => {
        // The price field displays in the event's currency, so it is read with that
        // currency's separators — comma-stripping "14,25" would multiply by 1425.
        let totalUncommittedExpense = $('#price').val();
        if (typeof totalUncommittedExpense === 'string') {
            totalUncommittedExpense = parseLocaleNumber(totalUncommittedExpense);
        }
        selectedAmounts.forEach((item, i) => {
            let itemAmount = item.amount;
            if (typeof itemAmount === 'string') {
                itemAmount = parseLocaleNumber(itemAmount);
            }
            totalUncommittedExpense *= itemAmount;
        });

        $('#total').val(totalUncommittedExpense);
        $('#total').trigger('keypress');
        $('#total').trigger('keyup');
    };

    const availableList = (index) => {
        if (index === 0) {
            return list;
        }

        const excludedNames = [];
        selectedAmounts.forEach((item, i) => {
            if (i < index) {
                excludedNames.push(item.name);
            }
        });

        return list.filter((name) => {
            return !excludedNames.includes(name);
        });
    };

    const changeAmountValue = (index, key, value) => {
        const allList = JSON.parse(JSON.stringify(list));

        if (key === 'name' && !allList.includes(value)) {
            allList.push(value);
            setList(allList);
        }
        const data = JSON.parse(JSON.stringify(selectedAmounts));
        const selectedData = selectedAmountNames();

        if (selectedData.includes(value) && key === 'name') {
            /* empty */
        } else {
            data[index][key] = value;
            setSelectedAmounts(data);
        }
    };

    const selectedAmountNames = () => {
        const res = [];
        selectedAmounts.forEach((item) => {
            res.push(item.name);
        });

        return res;
    };

    const unitsObj = (index) => {
        const res = [];
        availableList(index).forEach((item, index) => {
            res.push({ label: item, value: item });
        });

        return res;
    };

    const addQuantity = (e) => {
        e.preventDefault();

        if (selectedAmounts.length >= 3) {
            return false;
        }

        const ind = selectedAmounts.length;
        const res = JSON.parse(JSON.stringify(selectedAmounts));

        res.push({
            name: availableList(ind)[0],
            amount: 1,
            expenseReadonly: props.expenseReadonly,
            canBeEdited: props.canBeEdited,
        });

        setSelectedAmounts(res);
    };

    const removeQuantity = (index) => {
        let res = JSON.parse(JSON.stringify(selectedAmounts));
        res.splice(index, 1);

        setSelectedAmounts(res);
    };

    const warningMessage =
        "This budget currently has a pending approval request and cannot be edited. See{' '}\n" +
        '                                <a href={props.requestsUrl} target={\'_blank\'} rel="noreferrer">\n' +
        '                                    here\n' +
        "                                </a>{' '}\n" +
        '                                for pending requests.';

    return (
        <div className="tw-flex tw-flex-col tw-my-4 tw-w-full">
            {props.errors}
            <h3 className="table__header tw-mb-3">{$t('Uncommitted')}</h3>
            <div className="tw-flex tw-flex-col tw-gap-y-4">
                <div className="inbud-table_wrapper !tw-border-0">
                    <table id="committed-table" className="inbud-table tw-table-auto">
                        <thead>
                            {!props.expenseReadonly && !!props.canBeEdited && selectedAmounts.length < 3 && (
                                <tr className="!tw-bg-transparent">
                                    <th className="!tw-bg-transparent" colSpan={2}></th>
                                    <th className="!tw-bg-transparent">
                                        <button className="button primary small tw-w-max" onClick={addQuantity}>
                                            {$t('Add another quantity')}
                                        </button>
                                    </th>
                                </tr>
                            )}

                            <tr className="tw-rounded-s-lg">
                                <th className="tw-min-w-40">{$t('Expense name')}</th>
                                <th className="tw-min-w-40">{$t('Price')}</th>
                                {selectedAmounts.length > 0 && (
                                    <Fragment>
                                        {selectedAmounts.map((expAmount, index) => {
                                            return (
                                                <Fragment key={index}>
                                                    <th className="tw-min-w-40">
                                                        {$t('Quantity')} {index + 1}
                                                    </th>
                                                    <th className="tw-min-w-60">{$t('Description')}</th>
                                                </Fragment>
                                            );
                                        })}
                                    </Fragment>
                                )}
                                <th className="tw-min-w-44">{$t('Total')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{expense.name}</td>
                                <td>
                                    <input
                                        type="text"
                                        className={`tw-w-full tw-rounded-lg !tw-bg-white tw-text-input-text tw-text-xs tw-font-semibold tw-border-0 thousands-format ${
                                            props.errors && props.errors.price ? 'is-invalid' : ''
                                        }`}
                                        data-decimals="any"
                                        id="price"
                                        name="price"
                                        onChange={changePrice}
                                        min=""
                                        max=""
                                        autoComplete="off"
                                        readOnly={!props.canBeEdited}
                                        disabled={!!props.expenseReadonly}
                                    />
                                </td>
                                {selectedAmounts.length > 0 && (
                                    <Fragment>
                                        {selectedAmounts.map((expAmount, index) => {
                                            return (
                                                <ExpenseQuantityEdit
                                                    key={`amount-${index}`}
                                                    helper={false}
                                                    index={index}
                                                    name={expAmount.name}
                                                    amount={expAmount.amount}
                                                    imageUrl={imgUrl}
                                                    assignedToEvent={assignedToEvent}
                                                    errors={errors}
                                                    units={availableLists[index]}
                                                    unitsObj={unitsObj(index)}
                                                    changeAmountValue={changeAmountValue}
                                                    expenseReadonly={!!props.expenseReadonly}
                                                    canBeEdited={!!props.canBeEdited}
                                                    removeQuantity={removeQuantity}
                                                />
                                            );
                                        })}
                                    </Fragment>
                                )}
                                <td className="tw-min-w-44">
                                    <input
                                        type="text"
                                        className={`tw-w-full tw-rounded-lg !tw-bg-white tw-text-input-text tw-text-xs tw-font-semibold tw-border-0 thousands-format ${
                                            props.errors && props.errors.total ? 'is-invalid' : ''
                                        }`}
                                        data-decimals="any"
                                        id="total"
                                        name="total"
                                        min=""
                                        max=""
                                        autoComplete="off"
                                        readOnly
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {!props.canBeEdited && props.showPendingRequestWarning && <HasPendingRequestWarning url={props.requestsUrl} />}
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('uncommittedTable')) {
    const root = document.getElementById('uncommittedTable');
    ReactDOM.render(
        <App>
            <UncommittedTable
                expenseReadonly={expenseReadonly}
                canBeEdited={canBeEdited === undefined ? true : canBeEdited}
                requestsUrl={requestsUrl}
                showPendingRequestWarning={typeof showPendingRequestWarning === 'undefined' ? true : !!showPendingRequestWarning}
            />
        </App>,
        root,
    );
}
